export const CASE_MENU = 'CASE_MENU';
export const RESET_CASE_MENU = 'RESET_CASE_MENU'


// WEBPACK FOOTER //
// ./src/components/common/CaseMenu/actions/actionTypes.js